import { Button, Table } from 'react-bootstrap'
import { Trash2, SquarePen } from 'lucide-react'
import moment from 'moment'
import { tableHeaderStyle } from './constants'

const RequestTable = ({
  requestCommand,
  detail,
  handleUpdateRequest,
  setShowModalDeleteRequest,
  setSelectedRequest
}) => {
  return (
    <Table hover responsive style={{ fontSize: '12px' }}>
      <thead style={{ backgroundColor: '#f8f9fa' }}>
        <tr>
          <th className="p-2 align-middle" style={tableHeaderStyle}>
            No
          </th>
          <th
            className="p-2 align-middle"
            style={{ ...tableHeaderStyle, width: '30%' }}
          >
            Item Code - Name
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Item Alias
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Batch
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Expired
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Base Qty UOM
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Qty Kemasan
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {!requestCommand.length ? (
          <tr>
            <td colSpan={8} className="p-2 align-middle">
              Data Empty!
            </td>
          </tr>
        ) : (
          requestCommand.map((item, i) => {
            return (
              <tr key={i}>
                <td className="p-2 align-middle">{i + 1}</td>
                <td className="p-2 align-middle">
                  {item.item_code && item.item_name
                    ? `${item.item_code} - ${item.item_name}`
                    : item.item_code || item.item_name || '-'}
                </td>
                <td className="p-2 text-end align-middle">
                  {item.item_alias ?? '-'}
                </td>
                <td className="p-2 text-end align-middle">
                  {item.batch ?? '-'}
                </td>
                <td className="p-2 text-end align-middle">
                  {item.expired
                    ? moment(item.expired).format('DD-MM-YYYY')
                    : '-'}
                </td>
                <td className="p-2 text-end align-middle">
                  {item.qty ? `${item.qty} ${item.uom}` : '-'}
                </td>
                <td className="p-2 text-end align-middle">
                  {item.pack_qty ? `${item.pack_qty} ${item.pack_uom}` : '-'}
                </td>
                <td className="p-2 text-end align-middle">
                  <div className="d-flex gap-2 justify-content-end">
                    <Button
                      size="sm"
                      variant={
                        ['done', 'unassigned'].includes(detail?.draft_status)
                          ? 'secondary'
                          : 'danger'
                      }
                      className={
                        ['done', 'unassigned'].includes(detail?.draft_status)
                          ? 'opacity-25'
                          : ''
                      }
                      disabled={['done', 'unassigned'].includes(
                        detail?.draft_status
                      )}
                      onClick={() => {
                        setShowModalDeleteRequest(true)
                        setSelectedRequest(item.request_id)
                      }}
                    >
                      <Trash2 size={14} />
                    </Button>
                    <Button
                      size="sm"
                      variant="secondary"
                      className={
                        ['done', 'unassigned'].includes(detail?.draft_status)
                          ? 'opacity-25'
                          : ''
                      }
                      disabled={['done', 'unassigned'].includes(
                        detail?.draft_status
                      )}
                      onClick={() =>
                        handleUpdateRequest(
                          item.item_code || null,
                          item.item_name || null,
                          item.item_alias || null,
                          item.request_id || null
                        )
                      }
                    >
                      <SquarePen size={14} />
                    </Button>
                  </div>
                </td>
              </tr>
            )
          })
        )}
      </tbody>
    </Table>
  )
}

export default RequestTable
